export function addSearch() {

	const form = document.querySelector('.search')
  const field = form.querySelector('.search-field')
  const btn = form.querySelector('.search-btn')

  btn.addEventListener('click', (e)=> {
   if (!!field.value) {
      field.blur()
    } else {
      e.preventDefault()
      field.focus()
    }
  })

}


// WEBPACK FOOTER //
// ./src/search.js